export default __webpack_public_path__ + "static/media/css.50226b12.gif";